import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-tooth-line',
      title: t('service_dental'),
      description: t('service_dental_desc'),
      color: 'from-teal-500 to-cyan-500',
    },
    {
      icon: 'ri-scissors-cut-line',
      title: t('service_plastic'),
      description: t('service_plastic_desc'),
      color: 'from-pink-500 to-rose-500',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: t('service_antiaging'),
      description: t('service_antiaging_desc'),
      color: 'from-purple-500 to-indigo-500',
    },
    {
      icon: 'ri-bone-line',
      title: t('service_orthopedic'),
      description: t('service_orthopedic_desc'),
      color: 'from-orange-500 to-amber-500',
    },
    {
      icon: 'ri-eye-line',
      title: t('service_eye'),
      description: t('service_eye_desc'),
      color: 'from-emerald-500 to-teal-500',
    },
    {
      icon: 'ri-contrast-drop-line',
      title: t('service_skin'),
      description: t('service_skin_desc'),
      color: 'from-fuchsia-500 to-pink-500',
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: t('service_cancer'),
      description: t('service_cancer_desc'),
      color: 'from-red-500 to-rose-500',
    },
    {
      icon: 'ri-body-scan-line',
      title: t('service_spine'),
      description: t('service_spine_desc'),
      color: 'from-cyan-500 to-teal-500',
    },
    {
      icon: 'ri-stethoscope-line',
      title: t('service_proctology'),
      description: t('service_proctology_desc'),
      color: 'from-lime-500 to-green-500',
    },
    {
      icon: 'ri-parent-line',
      title: t('service_gynecology'),
      description: t('service_gynecology_desc'),
      color: 'from-violet-500 to-purple-500',
    },
    {
      icon: 'ri-health-book-line',
      title: t('service_checkup'),
      description: t('service_checkup_desc'),
      color: 'from-sky-500 to-cyan-500',
    },
    {
      icon: 'ri-user-heart-line',
      title: t('service_hair_transplant'),
      description: t('service_hair_transplant_desc'),
      color: 'from-amber-500 to-yellow-500',
    },
    {
      icon: 'ri-pulse-line',
      title: t('service_varicose'),
      description: t('service_varicose_desc'),
      color: 'from-rose-500 to-red-400',
    },
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('services_title')}
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {t('services_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg border border-gray-200 p-6 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-lg bg-gradient-to-br ${service.color} mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
